export default [
  {
    title: "Proxying HTTP/3 (QUIC) Using CONNECT-UDP with Envoy",
    authors: "Jeongseok Son",
    venue: "EnvoyCon (KubeCon + CloudNativeCon North America), Chicago, IL, November 2023",
    icons: [
      {
        icon: 'fas fa-globe',
        url: 'https://colocatedeventsna2023.sched.com/event/1Rj5y/proxying-http3-quic-using-connect-udp-with-envoy-jeongseok-son-google'
      },
      {
        icon: 'fas fa-video',
        url: 'https://www.youtube.com/watch?v=g0tfTVnZsto'
      },
      {
        icon: 'fas fa-laptop-code',
        url: 'https://github.com/envoyproxy/envoy/pull/27714'
      },
      {
        icon: 'fas fa-laptop-code',
        url: 'https://github.com/envoyproxy/envoy/pull/25925'
      }
    ]
  },
  {
    title: "ObliCheck: Efficient Verification of Oblivious Algorithms with Unobservable State",
    authors: "Jeongseok Son, Griffin Prechter, Rishabh Poddar, Raluca Ada Popa, and Koushik Sen",
    venue: "USENIX Security Symposium (Security), Virtual, August 2021",
    icons: [
      {
        icon: 'far fa-file-pdf',
        url: require('@media/2021.Security.Son.ObliCheck.pdf')
      },
      {
        icon: 'fas fa-video',
        url: 'https://www.usenix.org/conference/usenixsecurity21/presentation/son'
      }
    ]
  },
  {
    title: "Civet: An Efficient Java Partitioning Framework for Hardware Enclaves",
    authors: "Chia-Che Tsai, Jeongseok Son, Bhushan Jain, John McAvey, Raluca Ada Popa, and Donald E. Porter",
    venue: "USENIX Security Symposium (Security), Boston, MA, USA, August 2020",
    icons: [
      {
        icon: 'far fa-file-pdf',
        url: require('@media/2020.Security.Tsai.Civet.pdf')
      },
      {
        icon: 'fas fa-video',
        url: 'https://www.usenix.org/conference/usenixsecurity20/presentation/tsai'
      }
    ]
  },
  {
    title: "Protego: Cloud-Scale Multitenant IPsec Gateway",
    authors: "Jeongseok Son, Yongqiang Xiong, Kun Tan, Paul Wang, Ze Gan, and Sue Moon",
    venue: "USENIX Annual Technical Conference (ATC), Santa Clara, CA, USA, July 2017",
    icons: [
      {
        icon: 'far fa-file-pdf',
        url: require('@media/2017.ATC.Son.Protego.pdf')
      },
      {
        icon: 'far fa-file-powerpoint',
        url: require('@media/atc17_slides_son.pdf')
      },
      {
        icon: 'fas fa-video',
        url: 'https://www.usenix.org/conference/atc17/technical-sessions/presentation/son'
      }
    ]
  },
  {
    title: "Efficiently Restoring Virtual Machines",
    authors: "Bernhard Egger, Erik Gustafsson, Changyeon Jo, and Jeongseok Son",
    venue: "IFIP International Conference on Network and Parallel Computing (NPC), Guiyang, China, September 2013, and Springer International Journal of Parallel Programming (IJPP), Volume 43, Issue 3, June 2015",
    icons: [
      {
        icon: 'far fa-file-pdf',
        url: require('@media/2015.IJPP.Egger.VMCheckpoint.pdf')
      },
      {
        icon: 'fas fa-laptop-code',
        url: 'https://csap.snu.ac.kr/software/xencheckpointinginstallation'
      }
    ]
  },
  {
    title: "Efficient Live Migration of Virtual Machines Using Shared Storage",
    authors: "Changyeon Jo, Erik Gustafsson, Jeongseok Son, and Bernhard Egger",
    venue: "ACM SIGPLAN/SIGOPS International Conference on Virtual Execution Environments (VEE), Houston, TX, USA, March 2013",
    icons: [
      {
        icon: 'far fa-file-pdf',
        url: require('@media/2013.VEE.Jo.VMLiveMigration.pdf')
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/pages/PublicationPage/publication-items.js